import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useScreenRecognition } from '@reckitt/phx-husky.hooks.use-screen-recognition';
import { ScreenRecognitionContext } from './screen-recognition-context';
export function ScreenRecognitionProvider(_a) {
  var children = _a.children;
  var screenRecognition = useScreenRecognition();
  return _jsx(ScreenRecognitionContext.Provider, __assign({
    value: screenRecognition
  }, {
    children: children
  }), void 0);
}